import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';

const HeroSection: React.FC = () => {
  return (
    <Box sx={{ bgcolor: 'black', color: 'white', py: 12 }}>
      <Container maxWidth="md">
        <Typography variant="h2" align="center" gutterBottom sx={{ fontWeight: 800, mb: 3, color: 'white' }}>
          Generate Screenshots with a Simple API Call
        </Typography>
        <Typography variant="h6" align="center" sx={{ mb: 5, color: 'rgba(255,255,255,0.8)' }}>
          Powerful screenshot generation API for developers. Capture any website, 
          customize your output, and integrate in minutes.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button 
            component={Link} 
            to="/register" 
            variant="contained" 
            size="large"
            sx={{ 
              bgcolor: 'white', 
              color: 'black',
              px: 4,
              py: 1.5,
              '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' }
            }}
          >
            Start Free Trial
          </Button>
          <Button 
            component={Link} 
            to="/api-docs" 
            variant="outlined" 
            size="large"
            sx={{ 
              color: 'white',
              borderColor: 'white',
              px: 4,
              py: 1.5,
              '&:hover': { borderColor: 'white', bgcolor: 'rgba(255,255,255,0.1)' }
            }}
          >
            View Documentation
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;

